import React, { useEffect, useState } from "react";
import "./login.css";
import { Container, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
// import { loginUserAction } from "../../../redux/actions/AuthAction";
// import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import notify from "../../Notifcation";
import { Fade, Zoom } from "react-awesome-reveal";
import {
  getLoggedUserAction,
  loginUserAction,
} from "../../../redux/actions/AuthAction";
import InstallPWAButton from "../../InstallPWAButton/InstallPWAButton";
const Login = () => {
  const dispatch = useDispatch();
  const [Phone, setPhone] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [Password, setPassword] = useState("password");
  const [passwordInput, setPasswordInput] = useState("");
  const navegate = useNavigate();
  const validationValues = () => {
    if (Phone === "" || passwordInput === "") {
      notify("من فضلك ادخل البيانات ", "error");
      return;
    }
  };

  const onPasswordChange = (e) => {
    setPasswordInput(e.target.value);
  };
  const toggle = () => {
    if (Password === "password") {
      setPassword("text");
      return;
    }
    setPassword("password");
  };
  const handlesubmit = async (e) => {
    const error = validationValues();
    if (error) return;
    setIsPress(true);
    setLoading(true);
    await dispatch(
      loginUserAction({
        phoneNumber: Phone,
        password: passwordInput,
      })
    );
    setLoading(false);
    setIsPress(false);
  };

  const res = useSelector((state) => state.authReducer.loginUser);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (res.data && res.data.Token) {
            localStorage.setItem("tokenajindamuhami", res.data.Token);
            dispatch(getLoggedUserAction());
            notify("تم تسجيل الدخول بنجاح", "success");
            // setTimeout(() => {
            //   if (res.data.roleName === "admin") {
            //     window.location.href = "/admin";
            //   } else {
            //     navegate("/user/mainuserpage");
            //   }
            // }, 2000);
          } else if (
            res.data &&
            res.data.ResponseMessage === "PhoneNumber or Password is incorrect!"
          ) {
            notify("خطأ في كلمة السر او رقم الهاتف", "error");
          }
          if (
            res.data.ResponseMessage ===
            "Your account is not active please call the admin"
          ) {
            notify("هذا الأكونت غير مفعل", "error");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          if (
            res.data &&
            res.data.ResponseMessage === "PhoneNumber or Password is incorrect!"
          ) {
            notify("خطأ في كلمة السر او رقم الهاتف", "error");
          } else notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  const resCurrnt = useSelector((state) => state.authReducer.currentUser);

  useEffect(() => {
    // if (loading === false) {
    if (localStorage.getItem("tokenajindamuhami") !== null) {
      localStorage.setItem("userajindamuhami", JSON.stringify(resCurrnt));
      if (resCurrnt) {
        if (resCurrnt.RoleName === "User") {
          setTimeout(() => {
            window.location.href = "/user/mainuserpage";
          }, 1500);
        }
        if (resCurrnt.RoleName === "SubUser") {
          setTimeout(() => {
            window.location.href = "/user";
          }, 1500);
        }
        if (resCurrnt.RoleName === "Admin") {
          setTimeout(() => {
            window.location.href = "/admin";
          }, 1500);
        }
        if (resCurrnt.RoleName === "Editor") {
          setTimeout(() => {
            window.location.href = "/editor";
          }, 1500);
        }
      }
    }
    // }
  }, [resCurrnt]);

  // useEffect(() => {
  //   if (loading === false) {
  //     if (res) {
  //       if (res.data.token) {
  //         localStorage.setItem("tokenajindamuhami", res.data.token);
  //         localStorage.setItem("userajindamuhami", JSON.stringify(res.data));
  //         notify("تم تسجيل الدخول بنجاح", "success");
  //         // setTimeout(() => {
  //         //   window.location.href = "/";
  //         // }, 1500);
  //       } else {
  //         localStorage.removeItem("tokenajindamuhami");
  //         localStorage.removeItem("userajindamuhami");
  //       }

  //       if (
  //         res.data.responseMessage === "PhoneNumber or Password is incorrect!"
  //       ) {
  //         localStorage.removeItem("tokenajindamuhami");
  //         localStorage.removeItem("userajindamuhami");
  //         notify("كلمة السر او رقم الهاتف خطأ", "error");
  //       }

  //       setLoading(true);
  //     } else notify("كلمة السر او رقم الهاتف خطأ", "error");
  //   }
  // }, [loading]);
  // useEffect(() => {
  //   if (loading === false) {
  //     if (localStorage.getItem("tokenajindamuhami") !== null) {
  //       const dat = JSON.parse(
  //         atob(localStorage.getItem("tokenajindamuhami").split(".")[1])
  //       );

  //       if (
  //         dat[
  //           "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
  //         ] === "User"
  //       ) {
  //         setTimeout(() => {
  //           window.location.href = "/user/main";
  //         }, 1500);
  //       } else {
  //         setTimeout(() => {
  //           window.location.href = "/admin";
  //         }, 1500);
  //       }
  //     }
  //   }
  // }, [loading]);
  return (
    <div className="login">
      <Container>
        <div id="bar-progress" className="mt-5 mt-lg-0">
          <div className="step step-active">
            <h5 style={{ border: "3px solid blue" }}>تجربة مجانية</h5>
          </div>
          <div className="seperator"></div>
          <div className="step ">
            <h5 style={{ border: "3px solid yellow" }}>150 جنيه شهرياً</h5>
          </div>
          <div className="seperator"></div>
          <div className="step">
            <h5 style={{ border: "3px solid orange" }}>1500 جنيه سنوياً</h5>
          </div>
        </div>
        <InstallPWAButton />
        <div className="main-log">
          <div className="content-main">
            <Zoom triggerOnce="false">
              <h2>"تطبيق أعمال أجندة المحامي القضائية"</h2>
              <h3>
                أقوى تطبيق إلكتروني متخصص لتنظيم أجندة المحامي القضائية اليومية
                بداية من بيانات الموكلين والتوكيلات والدعاوي و أجندة المحامي
                القضائية و العمل الإداري <i className="fa-solid fa-check"></i>
              </h3>
            </Zoom>
            <Fade direction="right" triggerOnce="false">
              <h4 style={{ color: "rgb(62,191,190)" }}>
                بياناتك في أقصى درجات الأمان والسرية
              </h4>
              <h4>
                أفضل وأسهل تطبيق سحابي متخصص لتنظيم أجندة المحامي القضائية
                اليومية بداية من بيانات الموكلين والتوكيلات وأجندة المحامي
                القضائية والعمل الإداري
              </h4>{" "}
              <p>
                تطبيق أجندة المحامي القضائية يتيح لكم إمكانية إدارة القوائم
                المتنوعة داخل البرنامج (قائمة الموكلين، قائمة الخصوم، قائمة
                التوكيلات، قائمة جهات التوثيق، قائمة المحاكم، قائمة الدوائر،...)
                ويمكنكم اضافة البيانات داخل كل قائمة بتفاصيلها لسهولة الرجوع
                إليها في إي وقت وسهولة ودقة تنظيم العمل داخل البرنامج.
              </p>
            </Fade>

            <Fade direction="right" triggerOnce="false">
              <ul>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> تطبيق أجندة
                  المحامي القضائية يتيح لكم تسجيل كافة بيانات الموكلين وكذلك
                  كافة بيانات التوكيلات المختلفة وتنظيمها وترتيبها وعرضها بسهولة
                  ودقة وحفظ صورة من التوكيل وكذلك بيانات الخصوم وصفاتهم.
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> يمكنكم تطبيق
                  أعمال أجندة المحامي القضائية من إدخال بيانات الدعاوى بأنواعها
                  المختلفة مثل (الموكل وصفته والخصم وصفته، تاريخ رفع الدعوى،
                  ونوع الدعوي ورقمها المحكمة والدائرة، المستندات المقدمة في
                  الدعوى، وملخص للدعوى) ، كما يتيح لكم البرنامج إمكانية عرض كل
                  الدعاوي وسهولة البحث عن أي دعوى باسم الموكل أو صفته أو الخصم
                  أو بنوع الدعوى أو رقمها أو المحكمة.
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i> يمكنكم التطبيق من
                  إدخال بيانات أجندة المحامي القضائية مثل (تاريخ الجلسة والمحكمة
                  ورقم الدائرة ونوع الدعوى ورقم الدعوى واسم الموكل وصفته واسم
                  الخصم وصفته،والقرار و تاريخ الجلسة القادمة)
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>
                  يمكنكم التطبيق من البحث في كافة بيانات أجندة المحامي القضائية
                  للوصول لكافة البيانات والتواريخ والقرارات بمنتهى السهولة
                  والدقة مثل (تاريخ الجلسات الحالية والسابقة واللاحقة) كما يحتوي
                  التطبيق علي تنبية بمواعيد وتاريخ الجلسات القادمة
                  قبل معادها بيومين
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>
                  يمكنكم التطبيق من إدخال بيانات الأعمال الإدارية مما يتيح لكم
                  إمكانية متابعة العمل الإداري اليومي من خلال آجندة العمل
                  الإداري بإضافة المهام والأعمال المطلوب القيام بأدائها يوميا
                  وماتم تنفيذه منها وأي ملاحظات آخري 
                </li>
              </ul>
            </Fade>
          </div>
          <div className="login-container">
            <h2>تسجيل الدخول</h2>
            <div className="login">
              <TextField
                focused
                label="رقم الهاتف"
                variant="outlined"
                inputProps={{ maxLength: 15 }}
                type="number"
                value={Phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <p id="user"></p>
              <TextField
                focused
                label="كلمة المرور"
                variant="outlined"
                // value={Password}
                // type="password"
                // onChange={(e) => setPassword(e.target.value)}
                type={Password}
                onChange={onPasswordChange}
                value={passwordInput}
                name="password"
                className="form-control"
              />
              <button className="btn btn-primary e" onClick={toggle}>
                {Password === "password" ? (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-slash-fill"
                    viewBox="0 0 16 16">
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-fill"
                    viewBox="0 0 16 16">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                  </svg>
                )}
              </button>
              <p id="password"></p>

              {isPress && loading ? (
                <button
                  style={{ height: "50px", width: "211px", margin: "0 auto" }}>
                  <Spinner animation="border" role="status"></Spinner>
                </button>
              ) : (
                <button
                  style={{ height: "50px", width: "211px", margin: "0 auto" }}
                  onClick={handlesubmit}>
                  تسجيل الدخول
                </button>
              )}

              <div className="social">
                <a href="https://www.facebook.com/ajindamuhami/">
                  <i className="fa-brands fa-facebook"></i>
                </a>
                <a href="https://www.youtube.com/watch?v=5RwRC7tdlpk&list=PL-6EWK16rlYQ5elA3JXFb7tiedP5zG7jq">
                  <i
                    style={{ color: "#fff" }}
                    className="fa fa-brands fa-youtube"></i>
                </a>
              </div>

              <Link to="/" style={{ color: "blue" }}>
                انشاء حساب جديد
              </Link>
              <Link to="/forget" style={{ color: "red" }}>
                نسيت كلمة السر ؟
              </Link>
            </div>
            <h5 className="text-center wtsus">
              <a style={{ color: "#fff " }} href="https://wa.me/+201001122424">
                {" "}
                تواصل معنا واتساب
              </a>
              <b>
                {" "}
                <i
                  className="fa-brands fa-whatsapp"
                  style={{ color: "#fff" }}></i>
              </b>
            </h5>
          </div>
        </div>
      </Container>
      <ToastContainer autoClose={1200} />
    </div>
  );
};

export default Login;
